import React, { useEffect, useState } from 'react';
import mermaid from 'mermaid';
import './MermaidRenderer.css';

interface MermaidRendererProps {
  code: string;
  messageId: string;
}

const MermaidRenderer: React.FC<MermaidRendererProps> = ({ code, messageId }) => {
  const [svg, setSvg] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    renderDiagram();
  }, [code]);

  const renderDiagram = async () => {
    try {
      setIsLoading(true);
      setError('');
      
      // Initialize mermaid
      mermaid.initialize({ 
        theme: 'default',
        startOnLoad: false,
        securityLevel: 'loose',
        fontFamily: 'Inter, system-ui, sans-serif'
      });
      
      // Render diagram
      const { svg: renderedSvg } = await mermaid.render(
        `mermaid-${messageId}`, 
        code
      );
      
      setSvg(renderedSvg);
    } catch (err) {
      console.error('Mermaid rendering error:', err);
      setError(err instanceof Error ? err.message : 'Failed to render diagram');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="mermaid-loading">
        📊 Rendering diagram...
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="mermaid-error">
        ❌ Diagram error: {error}
      </div>
    );
  }
  
  return (
    <div className="mermaid-container">
      <div 
        className="mermaid-diagram"
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    </div>
  );
};

export default MermaidRenderer;
